module.exports = __webpack_public_path__ + "img/no-data.b3e0604e.png";